import { tv } from "../../../variants/tv.js";
const moduleFAQVariants = tv({
    slots: {
        gridWrapper: '@container w-full',
        grid: '@xl:gap-y-8 @5xl:gap-x-8 grid w-full gap-x-4 gap-y-6',
        faqItem: '@2xl:gap-3 flex flex-col gap-2'
    },
    variants: {
        variant: {
            grid: {},
            accordion: {
                grid: '@xl:gap-y-2 flex w-full flex-col gap-0'
            }
        },
        columns: {
            1: {
                grid: 'grid-cols-1'
            },
            2: {
                grid: '@2xl:grid-cols-2 grid-cols-1'
            },
            3: {
                grid: '@2xl:grid-cols-3 @lg:grid-cols-2 grid-cols-1'
            }
        },
        display: {
            simple: {},
            simpleCenter: {},
            simpleSplit: {},
            withImageCenter: {},
            withImage: {},
            splitWithImage: {}
        }
    },
    compoundVariants: [
        {
            columns: 1,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:max-w-1/2 @2xl:mx-auto'
            }
        },
        {
            columns: 2,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:max-w-2/3 @2xl:mx-auto'
            }
        },
        {
            variant: 'accordion',
            columns: [
                1,
                2,
                3
            ],
            display: [
                'simple',
                'simpleCenter',
                'simpleSplit',
                'withImageCenter',
                'withImage',
                'splitWithImage'
            ],
            class: {
                gridWrapper: '@2xl:max-w-none @2xl:mx-0'
            }
        }
    ],
    defaultVariants: {
        variant: 'grid',
        columns: 3
    }
});
export { moduleFAQVariants };
